export default __webpack_public_path__ + "static/media/pyszne-sm-light.2befb5dc.svg";